/*
Copyright 2025 TekNix Corporation

This software is proprietary and confidential to TekNix Corporation.
All rights reserved. No part of this software may be reproduced, distributed,
or transmitted in any form or by any means, including photocopying, recording,
or other electronic or mechanical methods, without the prior written permission
of TekNix Corporation, except in the case of brief quotations embodied in
critical reviews and certain other noncommercial uses permitted by copyright law.

For permission requests, write to TekNix Corporation at the address below:
TekNix Corporation
Legal Department

UNAUTHORIZED REPRODUCTION OR DISTRIBUTION IS STRICTLY PROHIBITED.
*/

export enum HistoryVisibility {
  Invited = 'invited',
  Joined = 'joined',
  Shared = 'shared',
  WorldReadable = 'world_readable',
}

export type IUsageLimit = {
  // "hs_disabled" is NOT a specced string, but is used in Synapse
  // This is tracked over at https://github.com/matrix-org/synapse/issues/9237

  limit_type: 'monthly_active_user' | 'hs_disabled' | string;

  admin_contact?: string;
};
